export default {"src":"/_next/static/media/SquareMinus.caa2ae74.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};